// extracted by mini-css-extract-plugin
export var equalColumn = "_hn-0";